import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import the translation files
import elTranslations from './locales/el/translation.json';
import enTranslations from './locales/en/translation.json';

// Function to get the initial language based on the URL
const getInitialLanguage = () => {
    if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        if (path.startsWith('/en/')) {
            return 'en';
        }
    }
    return 'el';
};

i18n
    .use(initReactI18next) // Pass the i18n instance to react-i18next.
    .init({
        lng: getInitialLanguage(),
        fallbackLng: 'el',
        debug: process.env.NODE_ENV === 'development',
        resources: {
            el: {
                translations: elTranslations,
            },
            en: {
                translations: enTranslations,
            },
        },
        ns: ['translations'],
        defaultNS: 'translations',
        returnObjects: true,
        interpolation: {
            escapeValue: false, // Not needed for React as it escapes by default
        },
    });

i18n.languages = ['el', 'en'];

export default i18n;
